enum BaseState {
  /**
   * Newly created entity.
   */
  New = 'new',
  /**
   * Ready to use entity.
   */
  Published = 'published',

  /**
   * Disabled entity.
   */
  Disabled = 'disabled',
}

export default BaseState;
